import { z } from 'zod';

/** One hosted-worker call (zemax_worker_calls row — the table keeps its
 *  historical name; it logs every external engine's worker hop).
 *  completedAt/status/error/durationMs are null while the call is in flight. */
export const ZemaxWorkerCallSchema = z.object({
  id: z.number(),
  userEmail: z.string(),
  conversationId: z.string().nullable(),
  engine: z.enum(['zemax', 'zemax-byo', 'codev']),
  /** Worker path without the leading slash, e.g. "run-optimization". */
  endpoint: z.string(),
  startedAt: z.string(),
  completedAt: z.string().nullable(),
  /** Worker HTTP status; null in flight or when the dispatch failed before a worker. */
  status: z.number().nullable(),
  error: z.string().nullable(),
  durationMs: z.number().nullable(),
  /** Which pool box served the call (worker's X-Worker-Id response header,
   *  its hostname). Null in flight, on dispatch/edge failures, and for BYO
   *  calls — the bridge tab relays status+body only, no headers. Optional
   *  only for deploy skew (the frontend can ship before the backend; the
   *  backend always sends the key) — tighten to required after a deploy. */
  workerId: z.string().nullable().optional(),
  /** Which uvicorn child on that box (X-Worker-Pid) — the unit that
   *  serializes work behind its ZOS-API lock. Same nullability/optionality
   *  as workerId. */
  workerPid: z.number().nullable().optional(),
});
export type ZemaxWorkerCall = z.infer<typeof ZemaxWorkerCallSchema>;

export const ZemaxWorkerCallListSchema = z.object({
  calls: z.array(ZemaxWorkerCallSchema),
});
export type ZemaxWorkerCallList = z.infer<typeof ZemaxWorkerCallListSchema>;
